import { Box, SxProps, useTheme } from '@mui/material';

import { IconButtonAnimate } from 'src/components/animate';
import { IconMenu } from 'src/libraries/icons';

//
//

type Props = {
  onToggleCollapse: VoidFunction;
  collapseClick: boolean;
  sx?: SxProps;
};

export default function CollapseButton({ onToggleCollapse, collapseClick, sx }: Props) {
  const theme = useTheme();

  return (
    <IconButtonAnimate onClick={onToggleCollapse} sx={{ ...sx }}>
      <Box
        sx={{
          lineHeight: 0,
          transition: (theme) =>
            theme.transitions.create('transform', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(collapseClick && {
            transform: 'rotate(180deg)',
          }),
        }}
      >
        <IconMenu color={theme.palette?.branded?.carbon} />
      </Box>
    </IconButtonAnimate>
  );
}
